import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import { HolidayResponse } from '../types';

export const getStudentHolidays = (
  eventStatus: string,
  leadId: string
): Promise<HolidayResponse> => {
  return axios.get('/comms/student-holidays', {
    params: {
      event_status: eventStatus,
      lead_id: leadId,
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getStudentHolidaysMockHandler = http.get(
  `${env.API_URL}/comms/student-holidays`,
  async (): Promise<HttpResponse<HolidayResponse>> => {
    await networkDelay();

    const mockResponse: HolidayResponse = {
      status: 'success',
      message: 'Holidays retrieved successfully',
      holidays: [
        {
          event_status: 'active',
          holiday_id: 'hol-001',
          holiday_name: 'New Year Day',
          holiday_date: 1_704_067_200, // Jan 1, 2024 timestamp
          allowed_countries: ['US', 'CA', 'GB'],
        },
        {
          event_status: 'active',
          holiday_id: 'hol-002',
          holiday_name: 'Independence Day',
          holiday_date: 1_720_137_600, // July 4, 2024 timestamp
          allowed_countries: ['US'],
        },
        {
          event_status: 'active',
          holiday_id: 'hol-003',
          holiday_name: 'Christmas Day',
          holiday_date: 1_735_084_800, // Dec 25, 2024 timestamp
          allowed_countries: ['US', 'CA', 'GB', 'AU'],
        },
        {
          event_status: 'active',
          holiday_id: 'hol-004',
          holiday_name: 'Diwali',
          holiday_date: 1_730_851_200, // Nov 5, 2024 timestamp
          allowed_countries: ['IN'],
        },
      ],
    };

    return HttpResponse.json(mockResponse);
  }
);
